export const WORKSPACE_STORAGE_NAME = 'workspaceId';
export const WORKSPACE_SEARCH_PARAM = 'workspace';

